// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-scroll-to-top[data-v-361a6926] {\n  position: fixed;\n  bottom: 5%;\n  z-index: 99;\n  opacity: 0;\n  transition: all 0.5s ease;\n}[dir=ltr] .btn-scroll-to-top[data-v-361a6926] {\n  right: 30px;\n}[dir=rtl] .btn-scroll-to-top[data-v-361a6926] {\n  left: 30px;\n}\n.btn-scroll-to-top.show[data-v-361a6926] {\n  opacity: 1;\n}", ""]);
// Exports
module.exports = exports;
